import { DefaultButton, Dropdown, IDropdownOption } from '@fluentui/react';
import * as React from 'react';

import { EntityType} from '../DataOwnerModels/CDMRecord';
import * as FormStyle from '../Styles/form.styled';
import { EntityTypePropertySelector, EntityTypePropertyValue } from './EntityTypePropertySelector';

export type JoinedEntityTypePropertySelectorProps = {
  readonly?: boolean;
  disabled?: boolean;
  entityTypes: EntityType[];
  joinableProperties: string[];
  value: ({ joinedProperty: string } & EntityTypePropertyValue) | null;
  onChange?(joinedProperty: string, value: EntityTypePropertyValue): void;
  onDone?(): void;
  onDelete?(joinProperty: string, entityTypeId: string): void;
};

export function JoinedEntityTypePropertySelector(props: JoinedEntityTypePropertySelectorProps): React.ReactElement {
  const handleJoinedPropertyUpdated = (e: unknown, option: IDropdownOption) => {
    props.onChange(option.key.toString(), null);
  };

  const handleUpdated = (value: EntityTypePropertyValue) => {
    props.onChange(props.value?.joinedProperty, value);
  };

  const handleAdded = () => {
    props.onDone();
  };

  if (props.readonly) {
    const entityType = props.entityTypes.find((et) => et.id === props.value?.entityTypeId);

    return (
      <Root>
        <FormStyle.InputGroup>
          <b>{entityType?.name}</b>: {(props?.value?.entityTypeProperties || []).join(', ')}
        </FormStyle.InputGroup>

        <DefaultButton
          text="Delete"
          onClick={() => props.onDelete(props.value?.joinedProperty, props.value?.entityTypeId)}
        />
      </Root>
    );
  }

  return (
    <Root>
      <FormStyle.InputGroup>
        <Dropdown
          label="Join property"
          options={(props.joinableProperties || []).map((p) => ({
            key: p,
            text: p,
          }))}
          selectedKey={props.value?.joinedProperty}
          onChange={handleJoinedPropertyUpdated}
          disabled={props.disabled}
        />
      </FormStyle.InputGroup>

      <EntityTypePropertySelector
        disabled={props.disabled || props.value?.joinedProperty == null}
        requiredProperty={props.value?.joinedProperty}
        entityTypes={props.entityTypes.filter(p => p.properties.indexOf(props.value?.joinedProperty || '') !== -1)}
        value={{
          entityTypeId: props.value?.entityTypeId,
          entityTypeProperties: props.value?.entityTypeProperties,
        }}
        onChange={handleUpdated}
      />

      <DefaultButton
        text="Add"
        disabled={props.disabled || props.value?.entityTypeProperties?.length === 0}
        onClick={handleAdded}
      />
    </Root>
  );
}

const Root = styled.div`
  padding: 12px;
  border: 1px solid #eaeaea;
  margin-bottom: 20px;
`;
